import React, { Component } from 'react';
/*
props {
	fileType: 'image/*',
	onChange: 
}
*/

class FileSelector extends Component {
	state = {
		allowMultipleImages: false
	};

	onFileUploadCB = null;

	onErrorCB = null;

	triggerClick = ({
		onFileUploadCB,
		onErrorCB,
		allowMultipleImages,
		imgFor = ''
	}) => {
		this.imgFor = imgFor;
		if (!!allowMultipleImages != this.state.allowMultipleImages) {
			this.onFileUploadCB = onFileUploadCB;
			this.onErrorCB = onErrorCB;
			this.setState(
				{
					allowMultipleImages
				},
				onFileUploadCB => {
					this.inputElem && this.inputElem.click();
				}
			);
		} else {
			this.onFileUploadCB = onFileUploadCB;
			this.onErrorCB = onErrorCB;
			this.inputElem && this.inputElem.click();
		}
	};
	render() {
		let allowMultipleImages = {};
		if (this.state.allowMultipleImages) {
			allowMultipleImages = {
				multiple: 'multiple'
			};
		}
		return (
			<div className='file-selector-div' style={{ display: 'none' }}>
				<input
					id='upload'
					type='file'
					accept={this.props.fileType}
					onChange={e => {
						this.props.onChange &&
							this.props.onChange(e, {
								inputElem: this.inputElem,
								onFileUploadCB: this.onFileUploadCB,
								onErrorCB: this.onErrorCB,
								imgFor: this.imgFor
							});
					}}
					onClick={e => {
						e.stopPropagation();
						e.target.value = null;
						this.props.onClick && this.props.onClick(e);
					}}
					ref={ref => (this.inputElem = ref)}
					{...allowMultipleImages}
				/>
			</div>
		);
	}
}

export default FileSelector;
